"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Link_meta_1 = require("../Link.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('a', Link_meta_1.LINK_CATEGORY_KEY, Link_meta_1.LINK_COMPONENT_KEY, ['anchor']);